
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/therapy/whats-worrying-you",
      function () {
        return require("private-next-pages/therapy/whats-worrying-you/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/therapy/whats-worrying-you"])
      });
    }
  